import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CancelButton, DeleteButton } from '../../../components/mui/Buttons/Buttons';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { deleteMilestoneAchievement } from '../../../redux/features/milestoneAchievementSlice';

/**
 * confirm and soft delete one milestone achievement.
 * @author Akhil E M
 * @createdAt 27-08-2026
 * @updates 27-08-2026(Akhil EM),
 * @type component
 */
const DeleteMilestone = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const { mutating } = useSelector((state) => state.milestoneAchievement);

  const handleDelete = async () => {
    const res = await dispatch(deleteMilestoneAchievement(row?.milestone_achievement_id));
    handleApiResponse(res, { onSuccess: () => onClose(true) });
  };

  return (
    <Stack spacing={2} sx={{ pt: 1 }}>
      <Typography variant="body2">
        Delete the milestone <strong>{row?.milestone_title}</strong> for <strong>{row?.user_name}</strong>?
      </Typography>
      {/* WHETHER THE RECIPIENT HAS ALREADY SEEN IT CHANGES WHAT DELETING ACTUALLY COSTS */}
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {row?.seen_on
          ? 'This milestone has already been celebrated with the employee.'
          : 'This milestone has not been celebrated yet — deleting it means it never will be.'}
      </Typography>
      <Stack direction="row" spacing={1.5} justifyContent="flex-end">
        <CancelButton action={() => onClose(false)}>Cancel</CancelButton>
        <DeleteButton disabled={mutating} action={handleDelete}>
          {mutating ? 'Deleting...' : 'Delete'}
        </DeleteButton>
      </Stack>
    </Stack>
  );
};

export default DeleteMilestone;
